var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_2182_23602)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9998 14C19.6365 14 17.7207 15.9158 17.7207 18.2791V21.2558C17.7207 23.6191 19.6365 25.5349 21.9998 25.5349C23.9981 25.5349 25.6765 24.1651 26.1472 22.3132C26.2026 22.0953 26.2302 21.9864 26.1633 21.9001C26.0962 21.814 25.9756 21.814 25.7343 21.814H23.4881C23.1799 21.814 22.93 21.5641 22.93 21.2558C22.93 20.9476 23.1799 20.6977 23.4881 20.6977H25.8323C26.0428 20.6977 26.1481 20.6977 26.2134 20.6323C26.2788 20.5669 26.2788 20.4616 26.2788 20.2512V19.2837C26.2788 19.0732 26.2788 18.968 26.2134 18.9026C26.1481 18.8372 26.0428 18.8372 25.8323 18.8372H23.4881C23.1799 18.8372 22.93 18.5873 22.93 18.2791C22.93 17.9708 23.1799 17.7209 23.4881 17.7209H25.7343C25.9756 17.7209 26.0962 17.7209 26.1633 17.6347C26.2302 17.5485 26.2026 17.4396 26.1472 17.2217C25.6765 15.3698 23.9981 14 21.9998 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2118 20.6973C16.6114 20.6973 16.9353 21.0176 16.9353 21.4128C16.9353 24.1792 19.2028 26.4218 21.9999 26.4218C24.797 26.4218 27.0645 24.1792 27.0645 21.4128C27.0645 21.0176 27.3884 20.6973 27.788 20.6973C28.1876 20.6973 28.5115 21.0176 28.5115 21.4128C28.5115 24.7277 25.9792 27.4577 22.7234 27.8136V28.5684H24.1705C24.57 28.5684 24.894 28.8888 24.894 29.2841C24.894 29.6792 24.57 29.9996 24.1705 29.9996H19.8294C19.4298 29.9996 19.1059 29.6792 19.1059 29.2841C19.1059 28.8888 19.4298 28.5684 19.8294 28.5684H21.2764V27.8136C18.0206 27.4577 15.4883 24.7277 15.4883 21.4128C15.4883 21.0176 15.8122 20.6973 16.2118 20.6973Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2182_23602",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/Mic.4cb3c986790b604e7787606f43b5c35b.svg";
export { ForwardRef as ReactComponent };